module.exports = __webpack_public_path__ + "static/img/2_1_3.f0f5dc7f.jpg";